// src/redux/actions/authActions.js
import { verifyEmail as verifyEmailService, login as loginService } from '../../services/authService';

export const verifyEmail = (email) => async (dispatch) => {
  try {
    await verifyEmailService(email);
    return true;
  } catch (error) {
    dispatch({
      type: 'ADD_TOAST',
      payload: { id: Date.now(), message: 'Try again', variant: 'danger' },
    });
    return false;
  }
};

export const login = (email, password) => async (dispatch) => {
  try {
    const data = await loginService(email, password);
    dispatch({ type: 'LOGIN_SUCCESS', payload: data });
    return true;
  } catch (error) {
    dispatch({
      type: 'ADD_TOAST',
      payload: { id: Date.now(), message: 'Try again', variant: 'danger' },
    });
    return false;
  }
};

export const logout = () => (dispatch) => {
  dispatch({ type: 'LOGOUT' });
};


export const addToast = (toast) => ({
  type: 'ADD_TOAST',
  payload: toast,
});

export const removeToast = (id) => (dispatch) => {
  dispatch({ type: 'REMOVE_TOAST', payload: id });
};
